import React from 'react'
import { useLanguage } from 'utils/translate.js'
import translations from '../TermsPage/translations.js'
import ReactMarkdown from 'react-markdown'
import { back } from 'redux-first-router'
import { t } from 'ttag'
import styles from './Terms.module.scss'
import { WaveContainer } from '../WaveContainer/WaveContainer'
import { BoldButton } from 'components/shared/BoldButton/BoldButton'
import BackIcon from 'assets/icons/back-arrow-white.svg'

export const Terms = ({ lc = 'en' }) => {
  const language = useLanguage() || lc
  const { date, markdown } = translations[language]

  return (
    <WaveContainer>
      <div className={styles.terms}>
        <h1 className={styles.title}>{t`Terms of use and privacy`}</h1>
        <p>
          {t`Updated`}: {date}
        </p>
        <p>{t`By commencing the tests, you accept the terms of use and privacy policy presented in this agreement.`}</p>
        <ReactMarkdown children={markdown} />
        <p>{t`If you have any questions do not hesitate to contact us at ebber@ebber.com`}</p>
        <p>
          <em>{t`By commencing the tests, you accept the terms of use and privacy policy presented in this agreement.`}</em>
        </p>
      </div>
      <div className={styles.backButton}>
        <div className={styles.backButtonContent}>
          <BoldButton
            label={t`Back`}
            onClick={back}
            icon={BackIcon}
            isIconFirst
          />
        </div>
      </div>
    </WaveContainer>
  )
}
